import sendToSegment from './sendToSegment'

type UserEventMiddleware = (event: UserEvent) => void

interface UserEventContext {
  target?: string
  targetText?: any
  message?: string
  name?: string
}

export interface UserEvent {
  name: UserEvents
  context?: UserEventContext
}

export enum UserEvents {
  ElementClicked = 'Element Clicked',
  ScreenViewed = 'Screen Viewed',
  FormInvalidated = 'Form Invalidated',
  ErrorEncountered = 'Error Encountered',
  CardMoved = 'Card Moved',
  ResumeDownloaded = 'Resume Downloaded',
}

const middlewareStack: UserEventMiddleware[] = [sendToSegment]

export const dispatchUserEvent = (event: UserEvent) => {
  middlewareStack.forEach(middleware => middleware(event))
}
